// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LikeFilledSvg from "@ant-design/icons-svg/es/asn/LikeFilled";
import AntdIcon from '../components/AntdIcon';

var LikeFilled = function LikeFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: LikeFilledSvg
  }));
};

LikeFilled.displayName = 'LikeFilled';
export default React.forwardRef(LikeFilled);